import {
    AMEND_ORDER,
    AMEND_ORDER_FAILURE,
    AMEND_ORDER_SUCCESS,
    DELETE_ORDER,
    DELETE_ORDER_FAILURE,
    DELETE_ORDER_SUCCESS,
    FETCH_ORDER,
    FETCH_ORDER_FAILURE,
    FETCH_ORDER_RECEIPT,
    FETCH_ORDER_RECEIPT_FAILURE,
    FETCH_ORDER_RECEIPT_SUCCESS,
    FETCH_ORDER_SUCCESS,
    ORDER_CANCEL_SUCCESS,
    ORDER_RECENT_ALTERATION,
    RETRY_ORDER_SUCCESS,
    UPDATE_ORDER,
    UPDATE_ORDER_FAILURE,
    UPDATE_ORDER_SUCCESS,
} from 'store/actions/types';
import reducerHelper from 'helpers/reducers';

const initialState = {
    data: {},
    loading: false,
    receipt: {
        data: {},
        error: null,
        loading: false,
    },
    reservations: {},
};

export default function orders(state = initialState, action) {
    switch (action.type) {
        case AMEND_ORDER:
        case DELETE_ORDER:
        case FETCH_ORDER:
        case UPDATE_ORDER:
            return Object.assign({}, state, {
                loading: true,
            });

        case AMEND_ORDER_FAILURE:
        case DELETE_ORDER_FAILURE:
        case FETCH_ORDER_FAILURE:
            return Object.assign({}, state, {
                data: {},
                loading: false,
            });

        case UPDATE_ORDER_FAILURE:
            return Object.assign({}, state, {
                loading: false,
            });

        case FETCH_ORDER_SUCCESS:
            const fetchPOI = { [action.response.id]: action.response };

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, fetchPOI),
            });

        case AMEND_ORDER_SUCCESS:
        case UPDATE_ORDER_SUCCESS:
            const updateOrder = { [action.id]: action.response };

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, updateOrder),
                loading: false,
            });

        case ORDER_RECENT_ALTERATION:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.payload.id]: Object.assign({}, state.data[action.payload.id], {
                        recentAlteration: action.payload.status,
                    }),
                }),
            });

        case DELETE_ORDER_SUCCESS:
            const { id } = action.payload;

            const deletedData = reducerHelper.removeItemFromObject(state.data, id);

            return Object.assign({}, state, {
                data: deletedData,
                loading: false,
            });

        case FETCH_ORDER_RECEIPT:
            return Object.assign({}, state, {
                receipt: Object.assign({}, state, {
                    loading: true,
                }),
            });

        case FETCH_ORDER_RECEIPT_FAILURE:
            return Object.assign({}, state, {
                receipt: Object.assign({}, state, {
                    loading: false,
                }),
            });

        case FETCH_ORDER_RECEIPT_SUCCESS:
            return Object.assign({}, state, {
                receipt: Object.assign({}, state, {
                    data: Object.assign({}, state.data, {
                        [action.payload.id]: action.payload.response,
                    }),
                    loading: false,
                }),
            });

        case ORDER_CANCEL_SUCCESS:
            const { data } = action.payload;

            /**
             * We will update the data in the state, but update the reservation_status manually.
             * This is because of the time the API needs to cancel the bookings.
             */
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [data.id]: {
                        ...data,
                        reservation_status: 'canceled',
                    },
                }),
            });

        case RETRY_ORDER_SUCCESS:
            const { response } = action.payload;

            /**
             * We will update the data in the state, but update the reservation_status manually.
             * This is because of the time the API needs to cancel the bookings.
             */
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [response.id]: {
                        ...response,
                        reservation_status: 'canceled',
                    },
                }),
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/ordersReducer.js